import React, { Component } from "react"
import "./GreenItem.scss"

class GreenItem extends Component {
    constructor() {
        super();
        this.state = {}
    }
    render() {
        return (
            <div className="item">
                <div className={`icon ${this.props.icon ? " icon-text" : "icon-image"} icon-${this.props.ID}`}>
                    {this.props.icon}
                </div>
                <div className="text">
                    {this.props.name}
                </div>
            </div>
        )
    }
}

export default GreenItem;


// WEBPACK FOOTER //
// ./src/Components/GreenList/GreenItem.jsx